import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import ActivityItem from './ActivityItem';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import * as bookActions from '../../../actions/bookActions';
import * as bookService from '../../../services/domain/bookService';
import * as activityService from '../../../services/domain/activityService';
import * as translateService from '../../../services/translate/customTranslateService';
import SanitizedString from '../../common/SanitizedString';

class LessonItem extends Component {
  static propTypes = {
    lesson: PropTypes.any,
    index: PropTypes.number,
    withResults: PropTypes.bool,
    account: PropTypes.object,
    book: PropTypes.object,
    classroom: PropTypes.object,
    institution: PropTypes.object,
    bookActions: PropTypes.object,
    isTeacher: PropTypes.bool
  };

  constructor(context, props) {
    super(context, props);
    this.openLessonOrActivity = this.openLessonOrActivity.bind(this);
    this.findContent = this.findContent.bind(this);
  }

  //--------------------------------------------------------------------------------------------------------------------
  openLessonOrActivity(activityId, questionActivityId) {
    const { account, book, lesson, institution, classroom, bookActions } = this.props;

    if (book && book.content) {
      let { lessonFound, unitFound } = this.findContent(book, activityId);

      lessonFound = lessonFound ? lessonFound : lesson;
      if (bookService.isLinkActivity(lessonFound.format)) {
        bookActions.openLink(lessonFound.url);
      } else {
        bookActions.openResource({
          book,
          unit: unitFound,
          lesson: lessonFound,
          account,
          institution,
          classroom,
          questionActivityId
        });
      }
    }
  }

  findContent(book, activityId) {
    let lessonFound;
    let unitFound;
    book.content.forEach(unit => {
      unit.content.forEach(lesson => {
        let found = _.find(lesson.children, {
          activityId: activityId
        });
        if (lesson.activityId === activityId) {
          found = true;
        }
        if (found) {
          unitFound = unit;
          lessonFound = lesson;
          return found;
        }
      });
      if (lessonFound && unitFound) {
        return true;
      }
    });
    return { lessonFound, unitFound };
  }

  //--------------------------------------------------------------------------------------------------------------------
  getActivities(lesson) {
    const { withResults, isTeacher, classroom } = this.props;
    let activitiesArray = [];

    if (lesson) {
      lesson.children.forEach((activity, index) => {
        let activityIcon = activityService.getActivityIcon(activity.activityType);
        activitiesArray.push(
          <ActivityItem
            isTeacher={isTeacher}
            key={index}
            activity={activity}
            activityIcon={activityIcon}
            index={index}
            openActivity={this.openLessonOrActivity}
            withResults={withResults}
            lesson={lesson}
            classroom={classroom}
          />
        );
      });
    }
    return activitiesArray;
  }

  //--------------------------------------------------------------------------------------------------------------------
  renderLessonRow(lesson, index) {
    return (
      <div
        onClick={() => this.openLessonOrActivity(lesson.activityId)}
        className="activity-grades-container"
        key={lesson.activityId + index}
      >
        <div className="activity-name">
          <span className="ellipsis lesson">
            <SanitizedString rawString={translateService.translateObject(lesson.name)} />
          </span>
        </div>
      </div>
    );
  }

  //--------------------------------------------------------------------------------------------------------------------
  render() {
    const { lesson, index } = this.props;

    let lessonsArray = [this.renderLessonRow(lesson, index)];
    lessonsArray = [...lessonsArray, ...this.getActivities(lesson)];

    return lessonsArray;
  }
}

function mapStateToProps(state) {
  return {
    book: state.book.book,
    account: state.account,
    institution: state.school.school
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LessonItem);
